const inputFocusKey = Symbol('For input focus event');
const configuratorStateKey = Symbol('For product configurator state reads and writes');

export {
  inputFocusKey,
  configuratorStateKey,
};
